import { render, staticRenderFns } from "./ValidatedInvoicesDataTable.vue?vue&type=template&id=5ab20490&scoped=true"
import script from "./ValidatedInvoicesDataTable.vue?vue&type=script&lang=js"
export * from "./ValidatedInvoicesDataTable.vue?vue&type=script&lang=js"
import style0 from "./ValidatedInvoicesDataTable.vue?vue&type=style&index=0&id=5ab20490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab20490",
  null
  
)

export default component.exports